import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import featureFlags from '../../../util/featureFlags';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { VENDORS },
} = NAV_DATA;

const getVendors = (isInMegaMenuTest = false): MegaMenuNavItem => {
  const categoryChildren = [
    {
      title: 'Wedding Venues',
      path: '/wedding-vendors/wedding-venues',
    },
    {
      title: 'Photographers',
      path: '/wedding-vendors/wedding-photographers',
    },
    {
      title: 'Videographers',
      path: '/wedding-vendors/wedding-videographers',
    },
    {
      title: 'Caterers',
      path: '/wedding-vendors/wedding-catering',
    },
    {
      title: 'Florists',
      path: '/wedding-vendors/wedding-florists',
    },
    {
      title: 'Beauty Professionals',
      path: '/wedding-vendors/wedding-hair-makeup',
    },
    {
      title: 'Wedding Planners',
      path: '/wedding-vendors/wedding-planners',
    },
    {
      title: 'Bands & DJs',
      path: '/wedding-vendors/wedding-bands-djs',
    },
    {
      title: 'Cakes & Desserts',
      path: '/wedding-vendors/wedding-cakes-desserts',
    },
    {
      title: 'Bar\u00a0Services\u00a0&\u00a0Beverages',
      path: '/wedding-vendors/wedding-bar-services',
    },
  ];

  const locationChildren = [
    {
      title: 'New York',
      path: '/wedding-vendors/search/new-york-ny--wedding-venues',
    },
    {
      title: 'Chicago',
      path: '/wedding-vendors/search/chicago-il--wedding-venues',
    },
    {
      title: 'Los Angeles',
      path: '/wedding-vendors/search/los-angeles-ca--wedding-venues',
    },
    {
      title: 'Atlanta',
      path: '/wedding-vendors/search/atlanta-ga--wedding-venues',
    },
    {
      title: 'Philadelphia',
      path: '/wedding-vendors/search/philadelphia-pa--wedding-venues',
    },
    {
      title: 'Dallas',
      path: '/wedding-vendors/search/dallas-tx--wedding-venues',
    },
    {
      title: 'Boston',
      path: '/wedding-vendors/search/boston-ma--wedding-venues',
    },
    {
      title: 'Austin',
      path: '/wedding-vendors/search/austin-tx--wedding-venues',
    },
    {
      title: 'Washington,\u00a0DC',
      path: '/wedding-vendors/search/washington-dc--wedding-venues',
    },
    {
      title: 'See All',
      path: '/wedding-vendors/search/wedding-venues',
      arrowLink: true,
    },
  ];

  const learnMoreChildren = [
    {
      title: 'Become A Vendor',
      path: 'https://welcome.zola.com/for-vendors/',
    },
    {
      title: 'Vendor FAQs',
      path: 'https://help.zola.com/hc/en-us/categories/360000467031-Vendor-Listings-Real-Weddings',
    },
    {
      title: 'Vendor\u00a0Expert\u00a0Advice',
      path: '/expert-advice/topic/planning-101/hiring-vendors',
    },
  ];

  const inspirationChildren = [
    {
      title: 'Get\u00a0Inspired',
      path: '/inspiration',
    },
  ];

  const inspirationStyleTestChildren = [
    {
      title: 'Find\u00a0your\u00a0wedding\u00a0style',
      path:
        featureFlags.getEnvironment() === 'production'
          ? 'https://quiz.zola.com/flow/stylequiz/variant/5-4-final'
          : 'https://quiz.zola.com/flow/stylequiz/variant/5-4-final-qa',
    },
  ];

  return {
    title: 'Vendors',
    id: VENDORS,
    path: '/wedding-vendors',
    parent: 'Vendors',
    callToAction: {
      path: '/wedding-vendors',
      title: 'Browse Vendors',
      items: [
        'Exceptional vendors for every couple, all pre-screened for you',
        'Personalized recs based on your unique wedding vision',
        'Sleek, simplified experience with ad-free search results',
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Vendor Inquiries',
        path: '/wedding-vendors/inquiries',
      },
      {
        title: 'Your Booked Vendors',
        path: '/wedding-vendors/inquiries/booked',
      },
    ],
    children: [
      {
        headline: 'By Category',
        children: categoryChildren,
      },
      {
        headline: 'By Location',
        children: locationChildren,
      },
      {
        headline: 'Learn More',
        children: learnMoreChildren,
        secondHeadline: 'Real\u00a0Weddings',
        secondChildren: isInMegaMenuTest ? inspirationStyleTestChildren : inspirationChildren,
      },
    ],
  };
};

export default getVendors;
